import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

const MmdaZoneGroupChart = ({ chartData }) => {
  if (!chartData || chartData.length === 0) {
    return (
      <div style={{ 
        padding: '20px', 
        textAlign: 'center', 
        color: '#666',
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        No MMDA, Zone, or Group data available
      </div>
    );
  }

  const data = {
    labels: chartData.map(item => item.name),
    datasets: [
      {
        data: chartData.map(item => item.count),
        backgroundColor: [
          '#FF6384',
          '#36A2EB',
          '#FFCE56',
          '#4BC0C0',
          '#9966FF',
          '#FF9F40',
          '#FF6384',
          '#C9CBCF',
        ],
        borderWidth: 2,
        borderColor: '#fff',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          padding: 20,
          usePointStyle: true,
          font: {
            size: 12
          }
        }
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const label = context.label || '';
            const value = context.parsed || 0;
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const percentage = ((value / total) * 100).toFixed(1);
            return `${label}: ${value} (${percentage}%)`;
          }
        }
      }
    },
  };

  return (
    <div style={{
      padding: '20px',
      borderRadius: '8px',

      marginBottom: '20px'
    }}>
      <h3 style={{ 
  marginTop: 0, 
  marginBottom: 15, 
  color: '#1976d2', 
  fontSize: 14,
  fontWeight: 'bold',
  textAlign: 'center'
}}
>
        MMDA, Zone, and Group Distribution
      </h3>
      <div style={{ height: '300px', position: 'relative' }}>
        <Doughnut data={data} options={options} />
      </div>
    </div>
  );
};

export default MmdaZoneGroupChart;